export const animationData = {
    "v": "5.2.1",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 340.000013848484,
    "w": 1000,
    "h": 1000,
    "nm": "Композиция 1",
    "ddd": 0,
    "assets": [{
        "id": "image_0",
        "w": 97,
        "h": 91,
        "u": "images/",
        "p": "Big_small_Figure.png",
        "e": 0
    }, {"id": "image_1", "w": 188, "h": 183, "u": "images/", "p": "Big_Figure.png", "e": 0}, {
        "id": "image_2",
        "w": 74,
        "h": 69,
        "u": "images/",
        "p": "Light_small_Figure.png",
        "e": 0
    }, {"id": "image_3", "w": 59, "h": 55, "u": "images/", "p": "Smaller_Figure.png", "e": 0}, {
        "id": "image_4",
        "w": 967,
        "h": 1032,
        "u": "images/",
        "p": "Inside_Figure_2.png",
        "e": 0
    }, {
        "id": "image_5",
        "w": 1075,
        "h": 1079,
        "u": "images/",
        "p": "Outside_Figure_2.png",
        "e": 0
    }, {
        "id": "comp_0",
        "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 2,
            "nm": "Big small/Figure.ai",
            "cl": "ai",
            "refId": "image_0",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [-360]
                    }, {"t": 299.00001217852}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [904.034, 151.186, 0], "ix": 2},
                "a": {"a": 0, "k": [48.5, 45.5, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 0,
                        "s": [90.977, 90.977, 100],
                        "e": [70, 70, 100]
                    }, {
                        "i": {"x": [0.825, 0.825, 0.825], "y": [1, 1, 1]},
                        "o": {"x": [0.301, 0.301, 0.301], "y": [0, 0, 0]},
                        "n": ["0p825_1_0p301_0", "0p825_1_0p301_0", "0p825_1_0p301_0"],
                        "t": 133,
                        "s": [70, 70, 100],
                        "e": [91, 91, 100]
                    }, {"t": 300.00001221925}],
                    "ix": 6
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 900.000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 2,
            "nm": "Big/Figure.ai",
            "cl": "ai",
            "refId": "image_1",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [360]
                    }, {"t": 297.000012097058}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [150.373, 323.288, 0], "ix": 2},
                "a": {"a": 0, "k": [94, 91.5, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 0,
                        "s": [70, 70, 100],
                        "e": [50, 50, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 60,
                        "s": [50, 50, 100],
                        "e": [70, 70, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 150,
                        "s": [70, 70, 100],
                        "e": [50, 50, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [0.861, 0.861, -7.646]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_0p861_0p333_0", "0p667_0p861_0p333_0", "0p667_-7p646_0p333_0"],
                        "t": 221,
                        "s": [50, 50, 100],
                        "e": [70, 70, 100]
                    }, {"t": 298.000012137789}],
                    "ix": 6
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 900.000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 2,
            "nm": "Light small/Figure.ai",
            "cl": "ai",
            "refId": "image_2",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [360]
                    }, {"t": 300.00001221925}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [247.153, 918.373, 0], "ix": 2},
                "a": {"a": 0, "k": [37, 34.5, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 0,
                        "s": [30, 30, 100],
                        "e": [90, 90, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 78,
                        "s": [90, 90, 100],
                        "e": [30, 30, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 178,
                        "s": [30, 30, 100],
                        "e": [90, 90, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 246,
                        "s": [90, 90, 100],
                        "e": [30, 30, 100]
                    }, {"t": 300.00001221925}],
                    "ix": 6
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 900.000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 2,
            "nm": "Smaller/Figure.ai",
            "cl": "ai",
            "refId": "image_3",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [-360]
                    }, {"t": 299.00001217852}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [479.661, 715.898, 0], "ix": 2},
                "a": {"a": 0, "k": [29.5, 27.5, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 0,
                        "s": [90.977, 90.977, 100],
                        "e": [70, 70, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 47,
                        "s": [70, 70, 100],
                        "e": [90, 90, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 149,
                        "s": [90, 90, 100],
                        "e": [70, 70, 100]
                    }, {
                        "i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 235,
                        "s": [70, 70, 100],
                        "e": [90, 90, 100]
                    }, {"t": 298.000012137789}],
                    "ix": 6
                }
            },
            "ao": 0,
            "ip": -321.000013074598,
            "op": 579.000023583154,
            "st": -321.000013074598,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 2,
            "nm": "Inside/Figure_2.ai",
            "cl": "ai",
            "refId": "image_4",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [-10]
                    }, {
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 57,
                        "s": [-10],
                        "e": [0]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "n": ["0p833_1_0p167_0"],
                        "t": 128,
                        "s": [0],
                        "e": [-10]
                    }, {
                        "i": {"x": [0.578], "y": [0.795]},
                        "o": {"x": [0.169], "y": [0]},
                        "n": ["0p578_0p795_0p169_0"],
                        "t": 185,
                        "s": [-10],
                        "e": [0]
                    }, {
                        "i": {"x": [0.686], "y": [1.013]},
                        "o": {"x": [0.341], "y": [0.116]},
                        "n": ["0p686_1p013_0p341_0p116"],
                        "t": 232,
                        "s": [0],
                        "e": [10]
                    }, {
                        "i": {"x": [0.81], "y": [1]},
                        "o": {"x": [0.438], "y": [0.02]},
                        "n": ["0p81_1_0p438_0p02"],
                        "t": 265,
                        "s": [10],
                        "e": [0]
                    }, {"t": 301.000012259981}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [500, 494, 0], "ix": 2},
                "a": {"a": 0, "k": [483.5, 516, 0], "ix": 1},
                "s": {"a": 0, "k": [92.497, 92.497, 100], "ix": 6}
            },
            "ao": 0,
            "ip": 0,
            "op": 900.000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 2,
            "nm": "Outside/Figure_2.ai",
            "cl": "ai",
            "refId": "image_5",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 0,
                        "s": [0],
                        "e": [12]
                    }, {
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p667_1_0p333_0"],
                        "t": 51,
                        "s": [12],
                        "e": [0]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "n": ["0p833_1_0p333_0"],
                        "t": 105,
                        "s": [0],
                        "e": [14]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "n": ["0p833_1_0p167_0"],
                        "t": 145,
                        "s": [14],
                        "e": [0]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "n": ["0p833_1_0p167_0"],
                        "t": 201,
                        "s": [0],
                        "e": [10]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "n": ["0p833_1_0p167_0"],
                        "t": 258,
                        "s": [10],
                        "e": [0]
                    }, {"t": 300.00001221925}],
                    "ix": 10
                },
                "p": {"a": 0, "k": [500, 500, 0], "ix": 2},
                "a": {"a": 0, "k": [537.5, 539.5, 0], "ix": 1},
                "s": {"a": 0, "k": [92.497, 92.497, 100], "ix": 6}
            },
            "ao": 0,
            "ip": 0,
            "op": 900.000036657751,
            "st": 0,
            "bm": 0
        }]
    }],
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 0,
        "nm": "Same",
        "refId": "comp_0",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.833], "y": [1]},
                    "o": {"x": [0.12], "y": [1.48]},
                    "n": ["0p833_1_0p12_1p48"],
                    "t": 0,
                    "s": [0],
                    "e": [40]
                }, {
                    "i": {"x": [0.833], "y": [1]},
                    "o": {"x": [0.167], "y": [0]},
                    "n": ["0p833_1_0p167_0"],
                    "t": 158,
                    "s": [40],
                    "e": [20]
                }, {
                    "i": {"x": [0.833], "y": [1]},
                    "o": {"x": [0.167], "y": [0]},
                    "n": ["0p833_1_0p167_0"],
                    "t": 257,
                    "s": [20],
                    "e": [0]
                }, {"t": 341.000013889215}],
                "ix": 10
            },
            "p": {"a": 0, "k": [500, 500, 0], "ix": 2},
            "a": {"a": 0, "k": [500, 500, 0], "ix": 1},
            "s": {"a": 0, "k": [76.751, 76.751, 100], "ix": 6}
        },
        "ao": 0,
        "w": 1000,
        "h": 1000,
        "ip": 0,
        "op": 900.000036657751,
        "st": 0,
        "bm": 0
    }],
    "markers": []
};